import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { TrendingUp, Layers, Flame } from "lucide-react";

export function MostUsedWidget() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/most-used-models").then((r) => setData(r.data)).catch(() => setData({ commodities: [], presets: [] }));
  }, []);
  if (!data) return null;
  const maxC = Math.max(1, ...(data.commodities || []).map((c) => c.count));
  return (
    <Card className="p-5 shadow-none" data-testid="most-used-widget">
      <div className="flex items-center gap-2 mb-1">
        <TrendingUp size={16} className="text-orange-500" />
        <h3 className="font-display font-semibold">Most-used models this month</h3>
        <span className="text-[11px] text-muted-foreground">· {data.month}</span>
      </div>
      <div className="grid md:grid-cols-2 gap-6 mt-3">
        <div data-testid="most-used-commodities">
          <div className="text-[11px] font-bold uppercase tracking-wider text-muted-foreground mb-2 flex items-center gap-1.5"><Layers size={12} /> Commodities (new projects)</div>
          {(data.commodities || []).length ? data.commodities.map((c) => (
            <div key={c.name} className="mb-2" data-testid={`muw-commodity-${c.name}`}>
              <div className="flex items-center justify-between text-sm mb-0.5"><span className="font-medium text-slate-700">{c.label}</span><span className="tabular-nums text-slate-500">{c.count}</span></div>
              <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-orange-500 rounded-full" style={{ width: `${(c.count / maxC) * 100}%` }} /></div>
            </div>
          )) : <p className="text-xs text-muted-foreground">No new projects this month yet.</p>}
        </div>
        <div data-testid="most-used-presets">
          <div className="text-[11px] font-bold uppercase tracking-wider text-muted-foreground mb-2 flex items-center gap-1.5"><Flame size={12} /> Top band recipes</div>
          {(data.presets || []).length ? data.presets.map((p, i) => (
            <div key={i} className="flex items-center justify-between text-sm py-1 border-b border-slate-100 last:border-0" data-testid={`muw-preset-${i}`}>
              <span className="font-medium text-slate-700 truncate">{p.name} <span className="text-[10px] font-mono text-slate-400">{p.commodity}</span></span>
              <span className="tabular-nums text-orange-600 font-semibold shrink-0">{p.uses} uses</span>
            </div>
          )) : <p className="text-xs text-muted-foreground">No band presets used yet.</p>}
        </div>
      </div>
    </Card>
  );
}
